define.alias("shared/components/shared/wizard/next-button", "calendar/components/shared/wizard/next-button");